export default __webpack_public_path__ + "static/paint-spray-third-c4828f60abbd1a4120d959400b83d970.webp";